export default __webpack_public_path__ + "static/Book Now_main image@2x-085e6b3bd60532120a5cadff3ccc87d9.jpg";